import { createFileRoute } from '@tanstack/react-router';

import { SettlementTab } from '@/features/deals';

export const Route = createFileRoute('/_app/deals/$dealId/settlement')({
  component: function Tab() {
    const { dealId } = Route.useParams();
    return <SettlementTab dealId={dealId} />;
  },
});
